import { Link } from 'react-router-dom';
import { footerContent } from '@/mocks/homeData';

export default function Footer() {
  const { brandName, description, contact, quickLinks, socialLinks } = footerContent;

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
                <i className="ri-plant-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-semibold font-heading text-background-50">
                {brandName}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300 mb-6">
              {description}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((link) => (
                <a
                  key={link.label}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-accent-500 hover:text-background-50 transition-all duration-300 cursor-pointer"
                  aria-label={link.label}
                >
                  <i className={`${link.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 font-label">
              快速链接
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 font-label">
              产品中心
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/categories"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  草坪草皮
                </Link>
              </li>
              <li>
                <Link
                  to="/categories"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  优质草种
                </Link>
              </li>
              <li>
                <Link
                  to="/categories"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  绿化服务
                </Link>
              </li>
              <li>
                <Link
                  to="/categories"
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-300 cursor-pointer"
                >
                  养护用品
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-5 font-label">
              联系我们
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-background-300">{contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-background-300">{contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-background-300">{contact.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-accent-400 mt-0.5"></i>
                <span className="text-sm text-background-300">{contact.workingHours}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {brandName} 版权所有 | 品质保证，正品直达
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-300 cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-300 cursor-pointer">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}